import { auth } from '@jaymathew/ui-shared/apis/FirebaseUtilities/FirebaseConfig'
import { onIdTokenChanged, User } from 'firebase/auth'
import { useEffect, useState } from 'react'

export function useAuthBootstrap() {
	// undefined = initializing, null = signed out, User = signed in
	const [user, setUser] = useState<User | null | undefined>(undefined)

	useEffect(() => {
		const off = onIdTokenChanged(auth, (u) => setUser(u ?? null))
		return () => off()
	}, [])

	return { user, initializing: user === undefined }
}
